import { takeLatest } from 'redux-saga/effects';
import { fetchEntitySpawn } from 'store/saga';
import URLHelper from './issueCreation.api';
import { FETCH_ISSUES, fetchIssues, SUBMIT_ISSUE, submitIssue } from './issueCreation.actions';
import { REQUEST } from 'utils/actionGenerator';

function* getIssuesSaga(action) {
  const request = URLHelper.getIssues(action.params);
  yield fetchEntitySpawn(request, fetchIssues, action.params);
}

function* createIssueSaga(action) {
  const request = URLHelper.updateIssue(action.params);
  yield fetchEntitySpawn(request, submitIssue, {
    toaster: { successMsg: 'Issue Created successfully' },
  });
}

function* IssuesSaga() {
  yield takeLatest(FETCH_ISSUES[REQUEST], getIssuesSaga);
  yield takeLatest(SUBMIT_ISSUE[REQUEST], createIssueSaga);
}

export default IssuesSaga;
